import React from 'react';
import { Link } from 'react-router-dom';
import TekyuLogo from './TekyuLogo';

export default function TermsOfService() {
  return (
    <div className="min-h-screen app-shell app-ambient">
      <div className="app-content mx-auto w-full max-w-4xl px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
        <div className="text-center mb-10">
          <Link to="/dashboard">
            <TekyuLogo className="h-16 w-auto mx-auto mb-6" />
          </Link>
          <h1 className="text-4xl font-extrabold text-white mb-4">Terms of Service</h1>
          <p className="text-slate-400">Last updated: 26 September 2026</p>
        </div>

        <div className="prose prose-invert max-w-none space-y-6 text-slate-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing and using Tekyu ("the Service"), you accept and agree to be bound by the terms and provision of this agreement.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. Description of Service</h2>
            <p>
              Tekyu provides personalized tech career roadmaps, hands-on projects, certification revision materials, and career planning tools.
              Tekyu learning tools are free; signing in is required to save work.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Free learning tools</h2>
            <p>Tekyu does not charge for its roadmaps, guided projects, revision tools or saved progress. External certification exams, cloud services and third-party courses may have their own fees. Cyber Agoge is a separate paid bootcamp with its own enrolment and terms.</p>
          </section>
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Previous subscriptions</h2>
            <p>New Tekyu subscriptions are no longer sold. This change does not automatically cancel a previous Stripe subscription or alter existing refund rights. Contact <a href="mailto:support@tekyu.co.uk" className="text-green-400">billing support</a> to check a previous payment or request cancellation.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. User Accounts</h2>
            <p>
              You are responsible for maintaining the confidentiality of your account credentials. You agree to notify us immediately of any unauthorized use.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Intellectual Property</h2>
            <p>
              All content, features, and functionality of the Service are owned by Tekyu and protected by international copyright laws.
              You may not reproduce, distribute, or create derivative works without permission.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. User Content</h2>
            <p>
              You retain ownership of content you create (roadmaps, projects, etc.). By using the Service, you grant Tekyu a license to store, 
              display, and process your content to provide the Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. Prohibited Uses</h2>
            <p>You agree not to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Use the Service for any illegal purpose</li>
              <li>Attempt to gain unauthorized access to the Service</li>
              <li>Share your account credentials</li>
              <li>Reverse engineer or attempt to extract source code</li>
              <li>Use automated systems to access the Service</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">9. Disclaimer of Warranties</h2>
            <p>
              The Service is provided "as is" without warranties of any kind. We do not guarantee that the Service will be uninterrupted, 
              error-free, or meet your specific requirements.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">10. Limitation of Liability</h2>
            <p>
              Tekyu shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">11. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Continued use of the Service after changes constitutes acceptance.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">12. Contact Information</h2>
            <p>
              For questions about these Terms, please contact us through the support channels provided in the Service.
            </p>
          </section>
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/dashboard"
            className="inline-flex items-center gap-2 text-green-400 hover:text-green-300 transition-colors"
          >
            ← Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
